import React, {ReactElement} from 'react';
import {useAppDispatch} from '../../../redux/hooks';
import offersIcon from '../../../assets/images/top_nav_offers_small.svg';
import rightArrowBlack from '../../../assets/images/right_arrow_black.svg';

// import BarcodeScanner from './BarcodeScanner';

type CustomerCoupon = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};
const ScannerView = ({
  onButtonClick,
  lsCouponPoints,
}: // onScan,
{
  onButtonClick: () => void;
  lsCouponPoints: CustomerCoupon[];
}): ReactElement => {
  const dispatch = useAppDispatch();

  return (
    <div className="mx-4">
      {lsCouponPoints && lsCouponPoints.length > 0 && (
        <div>
          <button
            onClick={onButtonClick}
            className="cursor-none-allowed flex justify-center h-50 mt-6 md:mt-10 place-items-center focus:outline-none  w-full text-center secondary normal">
            <div className="relative">
              <img className="mr-2 " src={offersIcon} />
              <div className="h-5 w-5 rounded-full absolute bottom-3 right-0 bg-red-600 text-white flex items-center justify-center">
                <div>{lsCouponPoints.length}</div>
              </div>
            </div>
            <p className="font-bold font-roboto flex">
              View unlocked offers&nbsp;{' '}
              <img src={rightArrowBlack} alt="View Unlocked Offers" />
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ScannerView;
